const THREE = require('three')
import * as ml from 'three.meshline'
import {svgToPath} from 'src/lib/transformSVGPath.js'
import raf from 'src/components/game/raf'
import {TimelineMax, TweenMax, Linear, Cubic} from 'gsap'
import _ from 'lodash'
import * as STAGES from '../../stages'
import {config as gameConfig} from '../../config'

let Line = require('three-line-2d')(THREE)
let BasicShader = require('three-line-2d/shaders/basic')(THREE)
let normalize = require('normalize-path-scale')
let DashShader = require('src/lib/line-shader-dashed')(THREE)

let started = false

// *****************************************************************
//
// Path
//
// *****************************************************************
let curve = new THREE.EllipseCurve(
  0,  0,            // ax, aY
  60, 60,           // xRadius, yRadius
  210 * THREE.Math.DEG2RAD,  // aStartAngle
  -30 * THREE.Math.DEG2RAD,  // aEndAngle
  true,            // aClockwise
  0                 // aRotation
)
let points = curve.getPoints( 200 ).map(function(item) {
  return [item.x, item.y]
})


points = normalize(points)


// *****************************************************************
//
// Constants
//
// *****************************************************************
const thicknessBar = 0.1
const colors = [
  0x0011FF,
  0xEB0033
]

// *****************************************************************
//
// BG Speedometer
//
// *****************************************************************
let bgGeometry = Line(points, { distances: true, closed: false })
export let dashMat = new THREE.ShaderMaterial(DashShader({
  side: THREE.DoubleSide,
  thickness: thicknessBar,
  dashSteps: 20,
  dashDistance: 0.42,
  dashSmooth: 0.01,
  diffuse: new THREE.Color(colors[0])
}))
let meshLineBg = new THREE.Mesh(bgGeometry, dashMat)
meshLineBg.geometry.drawRange.count = 0


// *****************************************************************
//
// Speedometer
//
// *****************************************************************
let geometry = Line(points, { distances: true, closed: false })
export let basicMat = new THREE.ShaderMaterial(BasicShader({
  side: THREE.DoubleSide,
  diffuse: new THREE.Color(colors[0]),
  thickness: thicknessBar
}))
let meshLine = new THREE.Mesh(geometry, basicMat)
meshLine.geometry.drawRange.count = 0

// *****************************************************************
//
// Starting animation
//
// *****************************************************************

export let start = (seconds) => {
  let tl = new TimelineMax({onComplete:() => {
    started = true
  }})
  tl.to(meshLineBg.geometry.drawRange, seconds, {count: meshLineBg.geometry.index.count, ease: Cubic.easeOut})
}

export let reset = (seconds) => {
  started = false
  meshLine.geometry.drawRange.count = 0
  meshLineBg.geometry.drawRange.count = 0
}



// *****************************************************************
//
// Updates
//
// *****************************************************************

// smooth counter animation
let smooth = { size: 0, color: 0 }
// let throttledAnim = _.throttle((sizeToReach, colorToReach) => {
//   sizeToReach = Math.round(sizeToReach)
//   TweenMax.to(smooth, refreshInt / 1000, {size: sizeToReach, ease: Linear.easeNone})
//   // TweenMax.to(smooth, refreshInt / 1000, {color: colorToReach, ease: Linear.easeNone})
// }, gameConfig.uiUpdateInterval)

let update = _.throttle(()=> {
  if (!window.game) return false
  if (!started) return false

  // UPDATE LENGTH
  let velMax = gameConfig.velocityMax
  let vel = window.game.state.velocity.now
  let velPercent = (vel / velMax) * 100
  let maxVerts = (meshLine.geometry.attributes.position.count * 3)
  let vertsStep = maxVerts / 100
  // throttledAnim(vertsStep * velPercent, vel / velMax)

  let sizeToReach = Math.round(vertsStep * velPercent)
  TweenMax.to(smooth, gameConfig.uiUpdateInterval / 1000, {size: sizeToReach, ease: Linear.easeNone})

  meshLine.geometry.drawRange.count = smooth.size

  // update colors according to speed
  // let speedColor = new THREE.Color(smooth.color, 0, 1 - smooth.color)
  // let speedColor = colors
  // basicMat.uniforms.diffuse.value = speedColor
  // dashMat.uniforms.diffuse.value = speedColor

  // UPDATE COLOR
  if (window.game.state.stage > STAGES.STAGE1) {
    toStage2()
  } else {
    toStage1()
  }
}, gameConfig.uiUpdateInterval)

// raf.on('tick', update)
setInterval(update, gameConfig.uiUpdateInterval)



let inStage2 = false
export const toStage1 = function () {
  if (!inStage2) return
  basicMat.uniforms.diffuse.value.set(colors[0])
  dashMat.uniforms.diffuse.value.set(colors[0])
  inStage2 = false
}



export const toStage2 = function (time = 0.8) {
  if (inStage2) return
  inStage2 = true
  const toColor = new THREE.Color(colors[1])
  TweenMax.to(basicMat.uniforms.diffuse.value, time, {
    r: toColor.r,
    g: toColor.g,
    b: toColor.b,
    ease: Cubic.easeOut,
    onUpdateParams: ['{self}'],
    onUpdate: function (tween) {
      dashMat.uniforms.diffuse.value.r = tween.target.r
      dashMat.uniforms.diffuse.value.g = tween.target.g
      dashMat.uniforms.diffuse.value.b = tween.target.b
    }
  })
  // basicMat.uniforms.diffuse.value = colors[0]
}



// *****************************************************************
//
// WRAP
//
// *****************************************************************

export let mesh = new  THREE.Object3D()
mesh.name = 'dashboard-speedometer'
mesh.add(meshLineBg)
mesh.add(meshLine)
mesh.scale.multiplyScalar(60)

export default mesh



// WEBPACK FOOTER //
// ./src/components/game/ui/dashboard/speedometer.js